export const AI_AUTOMATION_ROUTE_ITEMS = [
  { path: 'overview', alias: 'aiOverview', lazy: () => import('./Overview') },
  { path: 'training', alias: 'aiTraining', lazy: () => import('./Training') },
  { path: 'skills', alias: 'aiSkills', lazy: () => import('./Skills') },
  { path: 'behavior', alias: 'aiBehavior', lazy: () => import('./Behavior') },
] as const

export type AiAutomationRoute = (typeof AI_AUTOMATION_ROUTE_ITEMS)[number]['path']
